/**
 * Application Modal - Exports
 * Multi-step loan application flow components and utilities
 */

// Types
export * from "./types/applicationTypes";

// Hooks
export {
  ApplicationFormProvider,
  useApplicationFormStore,
  ApplicationFormContext,
  type ApplicationFormStore,
  type ApplicationFormState,
  type ApplicationFormActions,
} from "./hooks/useApplicationFormStore";

export {
  useDebouncedAutoSave,
  type SaveHandler,
  type SaveHandlerConfig,
  type AutoSaveOptions,
  type AutoSaveState,
  type UseDebouncedAutoSaveReturn,
} from "./autosave/useDebouncedAutoSave";

export {
  useApplicationLock,
  type UseApplicationLockReturn,
} from "./hooks/useApplicationLock";

export {
  useLockConflictDetection,
  type UseLockConflictDetectionReturn,
} from "./hooks/useLockConflictDetection";

// Form Components
export { PersonalInformationForm } from "./components/PersonalInformationForm";
export { PIIForm } from "./components/PIIForm";
export { MaritalStatusForm } from "./components/MaritalStatusForm";
export { EcoaForm } from "./components/EcoaForm";
export { AddressFormSection } from "./components/AddressFormSection";
export { NearestRelativeForm } from "./components/NearestRelativeForm";
export { EmploymentHistoryForm } from "./components/EmploymentHistoryForm";
export { FinancialAccountsForm } from "./components/FinancialAccountsForm";
export { AdditionalIncomeForm } from "./components/AdditionalIncomeForm";
export { ExpensesForm } from "./components/ExpensesForm";
export { HomeDetailsForm as PropertyDetailsForm } from "./components/HomeDetailsForm";
export { LandDetailsForm } from "./components/LandDetailsForm";
export { PricingCalculatorSection } from "./components/PricingCalculatorSection";
export { LenderSelectionSection } from "./components/LenderSelectionSection";
export { SignatureSection } from "./components/SignatureSection";
export { ApplicationLockTakeoverDialog } from "./components/ApplicationLockTakeoverDialog";
export { ApplicationLockConflictDialog } from "./components/ApplicationLockConflictDialog";
